import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import type { ColorToken } from '../../types';
import { Well } from '../Well';
import type { SpacingToken } from '../Well/types';

export type BainGenericContainerProps = StructuredContentDocument<{
  marginTop?: SpacingToken;
  marginBottom?: SpacingToken;
  marginLeft?: SpacingToken;
  marginRight?: SpacingToken;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
  paddingLeft?: SpacingToken;
  paddingRight?: SpacingToken;
  backgroundColor?: ColorToken;
  children: StructuredContentDocument;
}>;

export function BainGenericContainer(props: BainGenericContainerProps) {
  return <Well {...props} />;
}
